import { z } from "zod";

import { envSchema, jobRequestSchema } from "./schemas";
import { ConstEnum } from "@abacus/common";

export interface ChunkRunResult<T> {
  chunkIndex: number;
  errors: [number, string][];
  startIndex: number;
  success: number;
  total: number;
  values: [number, T][];
}

export type Env = z.infer<typeof envSchema>;

export interface Runner<I = unknown, O = unknown> {
  run(data: I): Promise<O>;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type RunnerCtor = new (config?: any) => Runner;

export type JobName = ConstEnum<typeof JobName>;
export const JobName = {
  CreateAbacusProfiles: "create_abacus_profiles",
  SapSyncContracts: "sap_sync_contracts",
  TerminateContracts: "terminate_contracts",
} as const;

export type JobRequest = z.infer<typeof jobRequestSchema>;

export interface JobResult {
  errors: [number, string][];
  total: number;
  values: [number, boolean][];
}
